import React from "react";
import { Helmet } from "react-helmet";

function TermsOfService() {
    return (
        <>
            <Helmet>
                <title>Terms of Service | 3PL Search</title>
            </Helmet>

            <div className="legal-page">
                <div className="container" style={{ maxWidth: "800px", padding: "3rem 1.5rem" }}>
                    <h1 style={{ color: "#132238", fontWeight: 800, marginBottom: "0.5rem" }}>Terms of Service</h1>
                    <p className="text-muted mb-4" style={{ fontSize: "0.9rem" }}>Last updated: {new Date().toLocaleDateString("en-GB", { day: "2-digit", month: "long", year: "numeric" })}</p>

                    <p>These Terms of Service govern your access to and use of the 3PL Search platform operated by Shipcube ("we", "us", or "our"). By using this platform, you agree to these terms.</p>

                    <h3>1. Eligibility</h3>
                    <p>You must be at least 18 years old and have the legal authority to enter into agreements on behalf of any company you represent. By using this platform you confirm both conditions are met.</p>

                    <h3>2. Platform Purpose</h3>
                    <p>3PL Search is a directory and matching platform connecting logistics buyers with third-party logistics (3PL) warehouse providers. We facilitate introductions and quote coordination but are not a party to any logistics contract formed between a buyer and a provider.</p>

                    <h3>3. Account Responsibilities</h3>
                    <ul>
                        <li>You are responsible for keeping your account credentials confidential</li>
                        <li>You must provide accurate, current, and complete information during registration</li>
                        <li>You are responsible for all activity that occurs under your account</li>
                        <li>Notify us immediately of any unauthorised access at <a href="mailto:support@shipcube.com">support@shipcube.com</a></li>
                    </ul>

                    <h3>4. Acceptable Use</h3>
                    <p>You agree not to:</p>
                    <ul>
                        <li>Submit false, misleading, or fraudulent information</li>
                        <li>Use the platform to solicit users for services outside the platform without our consent</li>
                        <li>Attempt to reverse-engineer, scrape, or disrupt the platform or its infrastructure</li>
                        <li>Violate any applicable local, national, or international laws</li>
                    </ul>

                    <h3>5. Provider Listings</h3>
                    <p>3PL providers are responsible for the accuracy of their listing information. We reserve the right to remove or edit any listing that violates our policies or is found to be inaccurate.</p>

                    <h3>6. No Guarantee of Match</h3>
                    <p>We do not guarantee that we will find a suitable 3PL provider for every buyer request, or that any provider will respond to or accept a quote request.</p>

                    <h3>7. Limitation of Liability</h3>
                    <p>To the maximum extent permitted by law, we are not liable for any indirect, incidental, or consequential damages arising from your use of the platform or from any transaction between a buyer and a provider facilitated through it.</p>

                    <h3>8. Intellectual Property</h3>
                    <p>All content on this platform, including the directory, design, and software, is owned by or licensed to us. You may not reproduce or redistribute it without written permission.</p>

                    <h3>9. Termination</h3>
                    <p>We reserve the right to suspend or terminate any account that violates these terms, without notice, at our sole discretion.</p>

                    <h3>10. Changes to These Terms</h3>
                    <p>We may update these terms at any time. Continued use after changes are posted constitutes acceptance of the new terms.</p>

                    <h3>11. Governing Law</h3>
                    <p>These terms are governed by applicable law. Disputes shall be resolved through good-faith negotiation; failing that, through appropriate legal channels.</p>

                    <h3>12. Contact</h3>
                    <p>For questions about these terms, contact us at <a href="mailto:legal@shipcube.com">legal@shipcube.com</a> or via our <a href="/contact">contact page</a>.</p>
                </div>
            </div>
        </>
    );
}

export default TermsOfService;
